import axios from "axios"

const baseUrl = process.env.REACT_APP_API_URL

const axiosInstance = axios.create({
  baseURL: baseUrl,
})

const requestInterceptor = (config) => {
  const {
    reduxSourceAction: { payload },
  } = config

  //const apiResponseType = responseType || 'json';
  //for multipartform
  //config.responseType = apiResponseType;
  const token = payload.auth && localStorage.getItem("token")

  const requestType = payload.multipartform
    ? "multipart/form-data"
    : "application/json"

  if (token) {
    config.headers.Authorization = `Token ${token}`
    config.headers["Content-type"] = requestType
  }

  return config
}

axiosInstance.interceptors.request.use(requestInterceptor)

export default axiosInstance
